import { useEffect, useState, useContext } from "react";
import $ from "jquery";
import { Card, Button, Form, Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import Alert from 'react-bootstrap/Alert';
import UserContext from "../../contexts/UserContext";

const Feedback = () => {
    const navigate = useNavigate();
    
    const [feedbackDates, setFeedbackDates] = useState([]);   
    const [availableMenus, setAvailableMenus] = useState([]);  
    const [feedbackDate, setFeedbackDate] = useState(null); 
    const [selectedMenu, setSelectedMenu] = useState(null);  
    const [feedbackType, setFeedbackType] = useState('quantity'); 
    const [mealType, setMealType] = useState('lunch');
    const [message, setMessage] = useState(null);
    const { user, setUser } = useContext(UserContext);

    async function getData(userId) {
        try {
            const response = await $.ajax({
                type: "GET",
                url: process.env.REACT_APP_API_URL + "/getUsers/" + userId,
                xhrFields: { withCredentials: true },
                crossDomain: true
            });

            if (response && response.user) {
                setUser(response.user);
            } else {
                setUser(null);
                navigate("/login", { state: { message: response.message } });
            }
        } catch (error) {
            console.log("Error getting user:", error);
            navigate("/login");
        }
    }

    const getDataTillNow = async () => {
        try {
            const response = await $.ajax({
                type: "GET",
                url: process.env.REACT_APP_API_URL + "/getFeedbackDates",
                xhrFields: { withCredentials: true },
                crossDomain: true
            });

            if (response && response.dates) {
                setFeedbackDates(response.dates);
                setAvailableMenus(response.menus || []);
            } else {
                navigate("/login", { state: { message: "Please Login!" } });
            }
        } catch (error) {
            console.log("Error fetching feedback dates:", error);
            navigate("/login", { state: { message: "Something went wrong!" } });
        }
    };

    const getMenuForDate = (e) => {
        const selectedDate = e.target.value;
        const menuForDate = availableMenus.find(menu => menu.date === selectedDate);
        
        setSelectedMenu(menuForDate ? menuForDate.menu : null);
        setFeedbackDate(selectedDate);
        setMealType('lunch'); // Reset to lunch when date changes
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return `${weekDays[date.getDay()]}, ${date.toLocaleDateString()}`;
    };

    const submitFeedbackData = async (e) => {
        e.preventDefault();
        
        const items = [];
        const inputElements = e.target.querySelectorAll('input[type="radio"]:checked');
        
        inputElements.forEach(input => {
            if (input.name !== 'feedbackType' && input.name !== 'mealType') {
                items.push({ [input.name]: input.value });
            }
        });

        if (e.target.comments && e.target.comments.value) {
            items.push({ comments: e.target.comments.value });
        }

        try {
            const response = await $.ajax({
                type: "POST",
                url: process.env.REACT_APP_API_URL + "/submitFeedback",
                data: {
                    items: items,
                    feedbackDate: feedbackDate,
                    feedbackType: feedbackType,
                    mealType: mealType
                },
                xhrFields: { withCredentials: true },
                crossDomain: true
            });

            if (response && response.message) {
                setMessage(response.message);
                e.target.reset();
                // Clear message after 3 seconds
                setTimeout(() => setMessage(null), 3000);
            } else {
                navigate("/login", { state: { message: "Please Login!" } });
            }
        } catch (error) {
            console.log("Error submitting feedback:", error);
            setMessage("Error submitting feedback. Please try again.");
        }
    };

    const getCurrentMealItems = () => {
        if (!selectedMenu) return [];
        
        if (mealType === 'lunch') {
            return selectedMenu.lunch?.isActive && selectedMenu.lunch.items ? selectedMenu.lunch.items : [];
        } else {
            return selectedMenu.dinner?.isActive && selectedMenu.dinner.items ? selectedMenu.dinner.items : [];
        }
    };

    const FeedbackCard = () => {
        const items = getCurrentMealItems();
        
        if (items.length === 0) {
            return (
                <Card className="mt-3">
                    <Card.Body className="text-center text-muted">
                        No {mealType} items available for this date
                    </Card.Body>
                </Card>
            );
        }

        return (
            <Card className="mt-3">
                <Card.Header style={{backgroundColor: '#c38154', color: 'white'}}>
                    {formatDate(feedbackDate)} - {mealType.charAt(0).toUpperCase() + mealType.slice(1)} {feedbackType.charAt(0).toUpperCase() + feedbackType.slice(1)} Feedback
                </Card.Header>
                <Card.Body>
                    <Form onSubmit={submitFeedbackData}>
                        {items.map((item, i) => (
                            <div key={i} className="mb-4">
                                <Card.Title style={{color: '#fff3cd'}}>{item}</Card.Title>
                                <Card.Text className="d-flex justify-content-around">
                                    {feedbackType === 'quantity' ? (
                                        <>
                                            <Form.Check
                                                type='radio'
                                                label='Less'
                                                name={item}
                                                value='less'
                                            />
                                            <Form.Check
                                                type='radio'
                                                label='Adequate'
                                                name={item}
                                                value='adequate'
                                            />
                                            <Form.Check
                                                type='radio'
                                                label='More'
                                                name={item}
                                                value='more'
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <Form.Check
                                                type='radio'
                                                label='Needs Improvement'
                                                name={item}
                                                value='needsImprovement'
                                            />
                                            <Form.Check
                                                type='radio'
                                                label='Average'
                                                name={item}
                                                value='average'
                                            />
                                            <Form.Check
                                                type='radio'
                                                label='Tasty'
                                                name={item}
                                                value='tasty'
                                            />
                                        </>
                                    )}
                                </Card.Text>
                            </div>
                        ))}

                        {feedbackType === 'quality' && (
                            <Form.Group className="mb-3">
                                <Form.Label>Comments:</Form.Label>
                                <Form.Control 
                                    as="textarea" 
                                    name='comments' 
                                    placeholder="Describe your feedback if any"
                                    rows={3}
                                />
                            </Form.Group>
                        )}

                        <Button 
                            className="mt-3" 
                            type='submit'
                            style={{backgroundColor: '#fff3cd', borderColor: '#fff3cd',color: '#c38154'}}
                        >
                            Submit Feedback
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        );
    };

    useEffect(() => {
        try {
            if (!user && localStorage.getItem('userSession')) {
                getData(JSON.parse(localStorage.getItem('userSession')));
            } else if (!user) {
                navigate("/login");
            }
        } catch (e) {
            if (!user) {
                navigate("/login");
            }
        }
    }, []);

    useEffect(() => {
        if (user) {
            getDataTillNow();
        }
    }, [user]);

    return (
        <Container fluid className="px-3">
            <Row className="justify-content-center">
                <Col xs={12} sm={10} md={8} lg={6} xl={5}>
                    <h6 className="m-3 text-center" style={{color: '#c38154'}}>
                        Menu Feedback
                    </h6>

                    {message && (
                        <Alert variant={message.includes('Error') ? 'danger' : 'success'}>
                            {message}
                        </Alert>
                    )}

                    <Form.Select 
                        className="mb-3" 
                        aria-label="Select Date" 
                        onChange={getMenuForDate}
                        style={{borderColor: '#c38154'}}
                    >
                        <option value="">Select Date For Feedback</option>
                        {feedbackDates.map((date, i) => (
                            <option key={i} value={date}>
                                {formatDate(date)}
                            </option>
                        ))}
                    </Form.Select>

                    {selectedMenu && feedbackDate && (
                        <>
                            {/* Meal Type Selection */}
                            <Card className="mb-3">
                                <Card.Body>
                                    <h6 style={{color: '#fff3cd'}}>Select Meal:</h6>
                                    <div className="d-flex justify-content-around">
                                        <Form.Check
                                            type='radio'
                                            label='Lunch'
                                            name='mealType'
                                            value='lunch'
                                            checked={mealType === 'lunch'}
                                            onChange={(e) => setMealType(e.target.value)}
                                        />
                                        <Form.Check
                                            type='radio'
                                            label='Dinner'
                                            name='mealType'
                                            value='dinner'
                                            checked={mealType === 'dinner'}
                                            onChange={(e) => setMealType(e.target.value)}
                                        />
                                    </div>
                                </Card.Body>
                            </Card>

                            {/* Feedback Type Selection */}
                            <Card className="mb-3">
                                <Card.Body>
                                    <h6 style={{color: '#fff3cd'}}>Feedback Type:</h6>
                                    <div className="d-flex justify-content-around">
                                        <Form.Check
                                            type='radio'
                                            label='Quantity'
                                            name='feedbackType'
                                            value='quantity'
                                            checked={feedbackType === 'quantity'}
                                            onChange={(e) => setFeedbackType(e.target.value)}
                                        />
                                        <Form.Check
                                            type='radio'
                                            label='Quality'
                                            name='feedbackType'
                                            value='quality'
                                            checked={feedbackType === 'quality'}
                                            onChange={(e) => setFeedbackType(e.target.value)}
                                        />
                                    </div>
                                </Card.Body>
                            </Card>

                            {/* Feedback Form */}
                            <FeedbackCard />
                        </>
                    )}

                    {selectedMenu && feedbackDate && getCurrentMealItems().length === 0 && (
                        <Alert variant="info">
                            No {mealType} menu available for the selected date.
                        </Alert>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default Feedback;